// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".dropdown__2_X4a{padding:10px 5px;color:black}.empty__VTg6N{color:#999999}.empty__VTg6N option{color:#000000}.empty__VTg6N option[value='']{color:#999999}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/components/Dropdown.module.scss"],"names":[],"mappings":"AAAA,iBACE,gBAAiB,CACjB,WAAY,CACb,cAGC,aAAc,CADhB,qBAGI,aAAc,CAHlB,+BAMI,aAAc","file":"Dropdown.module.scss","sourcesContent":[".dropdown {\n  padding: 10px 5px;\n  color: black;\n}\n\n.empty {\n  color: #999999;\n  option {\n    color: #000000;\n  }\n  option[value=''] {\n    color: #999999;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"dropdown": "dropdown__2_X4a",
	"empty": "empty__VTg6N"
};
module.exports = exports;
